<template>
    <v-card>
        <v-card-title class="headline primary darken-1 white--text justify-space-between">
            <span>{{ disableArgs.archive_action == 'unarchive' ? 'Unarchive this Project' : 'Project Visibility' }}</span>
            <v-btn 
                icon 
                outlined
                color="white"
                elevation="1"
                @click="closeDialog()">
                <v-icon >mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
            <div v-if="disableArgs.archive_action != 'unarchive'" 
                class="d-flex flex-grow-1 justify-space-between avenir_book label_size">
                <div class="d-flex d-inline" style="width: 50%">
                    <div class="d-inline mt-5 mr-4">Archive Project</div> 
                    <v-switch
                        v-model="disable_action"
                        inset
                        color="primary"
                        class="d-inline">
                    </v-switch>
                    <div class="d-inline mt-5 ml-0">Delete Project</div>
                </div>
                <v-select
                    v-model="archived_status"
                    :items="project_statuses"
                    item-text="internal_label"
                    item-value="value"
                    color="primary"
                    class="d-inline mb-4 pl-6 justify-end label_medium"
                    style="width: 50%"
                    hint="change the status?"
                    persistent-hint>
                </v-select>
            </div>
            <div v-else 
                class="d-flex justify-space-between avenir_book label_medium">
                <div class="d-inline mt-5" style="width: 50%">What status should we make it?</div> 
                <v-select
                    v-model="unarchived_status"
                    :items="project_statuses"
                    item-text="internal_label"
                    item-value="value"
                    color="primary"
                    class="mb-4 justify-end label_medium"
                    style="width: 50%">
                </v-select>
            </div>
            <v-divider></v-divider>
            <div class="pt-4 d-block">
                By clicking the confirm button below you are affirming that you want to <strong>{{ disableArgs.archive_action != 'unarchive' ? disable_action ? 'delete' : 'archive' : 'unarchive' }}</strong> this project. 
                <span v-if="mark_as_incomplete"><br>It will also be marked as "Incomplete".</span>
                <br><br>
                <span v-if="disableArgs.archive_action != 'unarchive' && !disable_action">This project will only be found in the archived projects area of the dashboard.</span>
                <span v-if="disableArgs.archive_action != 'unarchive' && disable_action">This project and all of it's questionnaire, psr, and meeting data will be completely removed from the database.</span>
                <span v-if="disableArgs.archive_action == 'unarchive'">This project will be found in the current projects area of the dashboard.</span>
                <br>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="align-center justify-space-between">
            <v-switch 
                v-model="hide_for_user"
                :label="hide_for_user ? 'Hidden from User\'s Dashboard' : 'Just Hide from User\'s Dashboard'"
                color="primary"
                class="ml-0 mt-1 mb-0"
                @change="hideForUser()">
            </v-switch>

            <v-btn 
                class="white--text" 
                color="primary darken-1"
                @click="disableArchive(disableArgs)">
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../../helpers/environment';

    export default {
        name: 'DisableProject',

        props: {
            disableArgs: Object,
            project_statuses: Array,
            closeProject: Function,
            refreshProject: Function,
            closeDisableDialog: Function,
            triggerUserFeedback: Function
        },

        data () {
            return {
                mark_as_incomplete: false,
                disable_action: false,
                archived_status: this.disableArgs.project_status,
                unarchived_status: this.disableArgs.project_status,
                hide_for_user: this.disableArgs.hide_for_user
            }
        },

        methods: {
            hideForUser: async function () {
                const projectId = this.disableArgs.remove_project_id
                const hide_for_user = this.hide_for_user
                const hide_project_for_user = await axios.put(`${appUrls.api}/api/admin/hide_project_for_user`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        project_id: projectId,
                        hide_for_user: hide_for_user
                    }
                })

                if ( hide_project_for_user ) {
                    if ( hide_project_for_user.data.outcome ) {
                        this.$emit( 'triggerUserFeedback', true, hide_project_for_user.data.message )
                        this.$emit( 'refreshProject', hide_project_for_user.data.project_data )
                    }
                } else {
                    (error) => { console.log(error) }
                }
            },

            disableArchive: async function () {
                // if ( this.mark_as_incomplete ) this.disableArgs.project_status = this.archived_status
                if ( this.disableArgs.archive_action != 'unarchive' ) {
                    this.disableArgs.project_status = this.archived_status
                    this.disableArgs.archive_action = this.disable_action ? 'remove' : 'archive'
                }
                if ( this.disableArgs.archive_action == 'unarchive' ) {
                    this.disableArgs.project_status = this.unarchived_status
                }
                this.disableProject( this.disableArgs );
            },

            disableProject: async function ( data ) {
                const projectId = data.remove_project_id
                const moduleName = data.remove_module_name
                const projectAction = data.archive_action
                const projectStatus = data.project_status
                this.$emit( 'closeDisableDialog', true )

                const disable_project = await axios.post(`${appUrls.api}/api/admin/disable_project`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        action: projectAction,
                        project_id: projectId,
                        module_name: moduleName,
                        project_status: projectStatus
                    }
                })

                if ( disable_project ) {
                    if ( disable_project.data.outcome ) {
                        this.$emit( 'triggerUserFeedback', true, disable_project.data.message )
                        if ( projectAction == 'remove' ) {
                            this.$emit('closeProject', true)
                        } else {
                            this.$emit( 'refreshProject', disable_project.data.project )
                        }                        
                    }
                } else {
                    (error) => { console.log(error) }
                }
            },

            closeDialog: function () {
                this.$emit( 'closeDisableDialog', false )
            }
        }
    }
</script>

<style scoped>
 .label_size {
    font-size: 1.2em;
}
</style>


// WEBPACK FOOTER //
// src/components/dialogs/DisableProject.vue